import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Home = () => {
  return (
    <div className="home-container">
      <h1>Welcome to the Modern Dashboard</h1>
      <p>Navigate using the menu or choose an option below:</p>
      <div className="home-buttons">
        <Link to="/account" className="welcome-btn">Go to Account</Link>
        <Link to="/upload" className="welcome-btn">Go to Upload</Link>
      </div>
    </div>
  );
};

export default Home;